import * as React from 'react';
interface PaymentCardProps {
    card: any;
    onSelectCard: () => void;
    selectedCard: any;
}

const PaymentCard: React.FunctionComponent<PaymentCardProps> = (
    props: PaymentCardProps
) => {
    const isSelected = props.selectedCard?.type === props.card?.type;

    return (
        <React.Fragment>
            <div
                data-test="pay-with-card-input"
                className="payment-card--block"
                onClick={props.onSelectCard}
            >
                <input
                    type="radio"
                    onChange={props.onSelectCard}
                    checked={isSelected}
                />
                <div className="payment-card--block--image-wrapper">
                    {props.card.icon}
                </div>
                <div>
                    <p className="payment-card--block-summary">
                        {props.card.label}
                    </p>
                </div>
            </div>
        </React.Fragment>
    );
};

export default PaymentCard;
